export default {
  business: '/business',
  businessSignUp: '/business/sign_up',
  businessLogin: '/business/login',
  businessForgotPassword: '/business/forgot-password',
  businessPasswordReset: '/business/password-reset/confirm/:uid/:token',
  businessPricing: '/business/pricing',
  businessFaq: '/business/faq',
  catering: '/catering',
  restaurant: '/restaurant',
  pros: '/pros',
  prosSignUp: '/pros/sign_up',
  prosFaq: '/pros/faq',
  shiftsPage: '/shifts',
  shiftPage: '/shifts/:slug',
  notFound: '/404',
  home: '/',
  contact: '/contact',
}


// WEBPACK FOOTER //
// ./src/routes.js